$(document).on('click', '#registrationLookupForm button', function (e) {
  e.preventDefault();

  let registrationNumber = $('#registrationNumberField').val();   


  if(registrationNumber.length > 0) {

    let data = {
      shopifyUrl: "trident-towing",
      reg: registrationNumber
    };

    let url = "https://trident.kayo.dev/api/regLookup";      
    let $registrationWrapper = $('.js-reg-lookup-wrapper');
    let loadingClass = 'loading';

    $.ajax({
      type: "POST",
      url: url,
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(data),
      beforeSend: function() {
        $('#registrationLookupForm').addClass('loading');
        $registrationWrapper.addClass(loadingClass);
        $('.result').addClass('d-none');
      },
      success: function(response){



        let vehicle = response[0];

        if(vehicle.VehicleImageData.length === 0){
          $('.car-image').attr('src', "//www.tridenttowing.co.uk/cdn/shop/t/62/assets/no-video-no-photo.png?v=26515482414035831611752222030");
        }      
        else {
          $('.car-image').attr('src', vehicle.VehicleImageData.VehicleImages.ImageDetailsList[0].ImageUrl)
        }


        if(!vehicle.VehicleData.SmmtDetails.Range){
          vehicle.VehicleData.SmmtDetails.Range = vehicle.VehicleData.VehicleRegistration.Model;
        }

        $('.result-manu').html(vehicle.VehicleData.ClassificationDetails.Dvla.Make);
        $('.result-series').html(vehicle.VehicleData.SmmtDetails.Series);
        $('.result-variant').html(vehicle.VehicleData.SmmtDetails.ModelVariant);
        $('.result-style').html(vehicle.VehicleData.SmmtDetails.BodyStyle);
        $('.result-model').html(vehicle.VehicleData.SmmtDetails.Range);

        
        $('.result-year').html(vehicle.VehicleData.VehicleRegistration.YearMonthFirstRegistered);
        $('.result-fuel').html(vehicle.VehicleData.SmmtDetails.FuelType);
        $('.result-colour').html(vehicle.VehicleData.VehicleRegistration.Colour);

        $('input#input-manufacturer').val(vehicle.VehicleData.ClassificationDetails.Dvla.Make)
        $('input#input-model').val(vehicle.VehicleData.SmmtDetails.Range)

        $('.result').removeClass('d-none');
        $('.vehicle-details-not-found').addClass('d-none');
        $('.vehicle-details').removeClass('d-none');
        gtag('event', 'conversion', {'send_to': 'AW-318106161/OSwgCNinnvMCELHU15cB'});

      
        
        $registrationWrapper.removeClass(loadingClass);
        $(document).ready(function(){
    		$("html,body").scrollTop(750);
		});
      },
      error: function(data){
        console.log('>>>Vehicle not found');
        $('.result').removeClass('d-none');
        $('.vehicle-details').addClass('d-none');
        $('.vehicle-details-not-found').removeClass('d-none');
        $('#registrationLookupForm').removeClass('loading');
        $registrationWrapper.removeClass(loadingClass);
      }
    });
  }

});

$(document).on('submit', 'form#tow-bar-fitting-enquiry', function (event) {
  event.preventDefault();
  // get the form data
  var form = $(this);
  var data = form.serializeArray();
  var formArray = getFormData(data);
  let url = "https://trident.kayo.dev/api/submitForm";

  formArray.registrationNumber = $('input#registrationNumberField').val();

  form.validate();
  
  if(form.valid()){
    $.ajax({
      type: "POST",
      url: url,
      contentType: 'application/json; charset=utf-8',
      dataType : 'json',
      data : JSON.stringify(formArray),
      beforeSend: function() {
        $("#js-form-submit").attr("disabled", true);
        $("#js-form-submit").html('Sending...')
      },
      success : function(response) {
        $('div#js-form-rollup').slideUp(600,function(){
          let headerHeight = $('.header').outerHeight();
          let navHeight =	$('nav').outerHeight();
          let scrollHeight = headerHeight + navHeight
          $("#js-form-submit").html('Sent!')
          $('html, body').animate({
            scrollTop: ($('#js-form-title').offset().top - scrollHeight)
          },500);
          $('div#js-form-submit-message').html(response.successMessage)
          
          window.location.replace("https://www.tridenttowing.co.uk/pages/tow-bar-enquiry-thank-you-page");
          
        });
      },
      error: function(xhr, resp, text) {
        console.log(xhr, resp, text);
      }
    })
  }

  //utility function
  function getFormData(data) {
    var unindexed_array = data;
    var indexed_array = {};

    $.map(unindexed_array, function(n, i) {
      indexed_array[n['name']] = n['value'];
    });

    return indexed_array;
  }

});


 

